(function () {
  var CDN = 'https://cdn.shopify.com/s/files/1/0780/2978/3192/files/';

  var FALLBACK_IMAGES = {
    'Harnais anti-traction': CDN + 'Photo_Produit_1.webp?v=1784026056',
    'Laisse double': CDN + 'Laisse_double.webp?v=1786179087',
    'Gourde Woufix': CDN + 'Gourde.webp?v=1786179087',
    'Ebook 4 étapes': CDN + 'ChatGPTImage8aout2026_16_05_01.webp?v=1786179935',
    'Ebook : laisse détendue en 4 étapes': CDN + 'ChatGPTImage8aout2026_16_05_01.webp?v=1786179935',
    'Sacoche à friandise': CDN + 'Sacoche.webp?v=1786179088',
    'Longe 3m': CDN + 'Longe_3m.webp?v=1786179086'
  };

  var DEFAULT_PACKS = {
    'Pack Promenade': {
      showInCart: true,
      packPrice: 79.90,
      items: [
        { name: 'Harnais anti-traction', noPrice: true },
        { name: 'Laisse double', originalPrice: 40.00, realPrice: 20.00 },
        { name: 'Gourde Woufix', originalPrice: 20.00, realPrice: 10.00 },
        { name: 'Ebook : laisse détendue en 4 étapes', originalPrice: 9.00, realPrice: 0 }
      ]
    },
    'Pack Complet': {
      showInCart: true,
      packPrice: 119.90,
      items: [
        { name: 'Harnais anti-traction', noPrice: true },
        { name: 'Laisse double', originalPrice: 40.00, realPrice: 20.00 },
        { name: 'Gourde Woufix', originalPrice: 20.00, realPrice: 10.00 },
        { name: 'Sacoche à friandise', originalPrice: 50.00, realPrice: 25.00 },
        { name: 'Longe 3m', originalPrice: 40.00, realPrice: 20.00 },
        { name: 'Ebook : laisse détendue en 4 étapes', originalPrice: 9.00, realPrice: 0 }
      ]
    }
  };

  function readConfiguredPacks() {
    var el = document.getElementById('woufix-pack-config');
    if (!el) return null;
    try {
      var parsed = JSON.parse(el.textContent);
      return (parsed && parsed.packs) || null;
    } catch (e) {
      return null;
    }
  }

  function buildPackData() {
    var configured = readConfiguredPacks();
    var packs = {};

    Object.keys(DEFAULT_PACKS).forEach(function (key) {
      packs[key] = DEFAULT_PACKS[key];
    });

    if (configured) {
      Object.keys(configured).forEach(function (key) {
        var cfg = configured[key];
        if (!cfg || !cfg.items || !cfg.items.length) return;
        packs[key] = {
          showInCart: cfg.showInCart !== false,
          packPrice: (typeof cfg.packPrice === 'number' ? cfg.packPrice : (DEFAULT_PACKS[key] ? DEFAULT_PACKS[key].packPrice : 0)),
          items: cfg.items.map(function (it) {
            var original = (typeof it.originalPrice === 'number') ? it.originalPrice : 0;
            var real = (typeof it.realPrice === 'number') ? it.realPrice : original;
            return { name: it.name, image: it.image || null, originalPrice: original, realPrice: real, noPrice: !!it.noPrice };
          })
        };
      });
    }

    return packs;
  }

  var PACKS = buildPackData();

  function formatEUR(amount) {
    return amount.toFixed(2).replace('.', ',') + '€';
  }

  function injectStyles() {
    if (document.getElementById('woufix-pack-breakdown-styles')) return;
    var style = document.createElement('style');
    style.id = 'woufix-pack-breakdown-styles';
    style.textContent =
      '.woufix-pack-breakdown{margin:-4px 0 16px;padding:12px 14px;border-radius:10px;background-color:#f6f4ef;}' +
      '.woufix-pack-breakdown__label{margin:0 0 8px;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.03em;color:#12203b;opacity:.75;}' +
      '.woufix-pack-breakdown__row{display:flex;align-items:center;gap:10px;padding:5px 0;}' +
      '.woufix-pack-breakdown__img{width:30px;height:30px;border-radius:7px;object-fit:cover;flex-shrink:0;background-color:#ffffff;display:block;}' +
      '.woufix-pack-breakdown__name{flex:1;min-width:0;font-size:12.5px;color:#12203b;}' +
      '.woufix-pack-breakdown__price{flex:0 0 auto;font-size:12px;text-align:right;}' +
      '.woufix-pack-breakdown__price s{display:block;opacity:.75;color:var(--woufix-compare-price-color, #6b6b6b);font-weight:400;}' +
      '.woufix-pack-breakdown__price-real{display:block;font-weight:700;color:var(--woufix-real-price-color, #1c7a3c);}' +
      '.woufix-pack-breakdown__price-real--free{text-transform:uppercase;font-size:11px;}';
    document.head.appendChild(style);
  }

  function buildBreakdownCard(pack) {
    var card = document.createElement('div');
    card.className = 'woufix-pack-breakdown';
    card.setAttribute('data-pack-breakdown', '');

    var label = document.createElement('p');
    label.className = 'woufix-pack-breakdown__label';
    label.textContent = 'Contenu du pack';
    card.appendChild(label);

    pack.items.forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'woufix-pack-breakdown__row';

      var imgSrc = item.image || FALLBACK_IMAGES[item.name];
      if (imgSrc) {
        var img = document.createElement('img');
        img.className = 'woufix-pack-breakdown__img';
        img.src = imgSrc;
        img.alt = item.name;
        img.loading = 'lazy';
        row.appendChild(img);
      }

      var name = document.createElement('span');
      name.className = 'woufix-pack-breakdown__name';
      name.textContent = item.name;
      row.appendChild(name);

      if (!item.noPrice) {
        var priceWrap = document.createElement('span');
        priceWrap.className = 'woufix-pack-breakdown__price';

        if (item.originalPrice > 0) {
          var s = document.createElement('s');
          s.textContent = formatEUR(item.originalPrice);
          priceWrap.appendChild(s);
        }

        var real = document.createElement('span');
        real.className = 'woufix-pack-breakdown__price-real woufix-pack-breakdown__price-real--free';
        real.textContent = 'Offert';
        priceWrap.appendChild(real);

        row.appendChild(priceWrap);
      }

      card.appendChild(row);
    });

    return card;
  }

  function matchPackKey(titleText) {
    if (!titleText) return null;
    var keys = Object.keys(PACKS);
    for (var i = 0; i < keys.length; i++) {
      if (titleText.indexOf(keys[i]) !== -1) return keys[i];
    }
    return null;
  }

  function swapCurrencyAfter(str) {
    return str.replace(/€\s*([\d.,]+)/g, '$1€');
  }

  function normalizeTextNodes(root) {
    if (!root || !document.createTreeWalker) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.indexOf('€') !== -1) {
        var swapped = swapCurrencyAfter(node.nodeValue);
        if (swapped !== node.nodeValue) node.nodeValue = swapped;
      }
    }
  }

  function normalizePriceSymbols() {
    var selectors = [
      '.pack-offer__price',
      '.pack-offer__compare-price',
      '.pack-offer__item-compare',
      '.pack-offer__item-normal-price',
      '.pack-offer__item-free',
      '#CartDrawer [data-cart-total]',
      '#CartDrawer [data-cart-savings-amount]',
      '#CartDrawer .woufix-cart-item__price'
    ];
    var els = document.querySelectorAll(selectors.join(','));
    els.forEach(function (el) { normalizeTextNodes(el); });
  }

  function injectBreakdowns() {
    var root = document.getElementById('CartDrawer');
    if (!root) return;
    var itemEls = root.querySelectorAll('.woufix-cart-item[data-cart-item]');
    itemEls.forEach(function (itemEl) {
      var next = itemEl.nextElementSibling;
      if (next && next.hasAttribute && next.hasAttribute('data-pack-breakdown')) return;

      var titleEl = itemEl.querySelector('.woufix-cart-item__title');
      var titleText = titleEl ? titleEl.textContent.trim() : '';
      var key = matchPackKey(titleText);
      if (!key) return;

      var pack = PACKS[key];
      if (!pack || pack.showInCart === false || !pack.items.length) return;

      var card = buildBreakdownCard(pack);
      itemEl.insertAdjacentElement('afterend', card);
    });
  }

  function init() {
    injectStyles();
    injectBreakdowns();
    normalizePriceSymbols();

    document.addEventListener('woufix:cart-updated', function () {
      injectBreakdowns();
      normalizePriceSymbols();
    });
    document.addEventListener('cart:refresh', function () {
      setTimeout(function () {
        injectBreakdowns();
        normalizePriceSymbols();
      }, 50);
    });

    var itemsWrap = document.getElementById('CartDrawer-CartItems');
    if (itemsWrap && window.MutationObserver) {
      var observer = new MutationObserver(function () {
        injectBreakdowns();
        normalizePriceSymbols();
      });
      observer.observe(itemsWrap, { childList: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();